export default __webpack_public_path__ + "static/media/f4.95ef88a1.png";